import { Box, DialogContent, DialogTitle } from "@mui/material";
import { customerContactBusiness } from "api/bussiness/customer/customer-contact-bussiness";
import { UpdateContact } from "api/models/request/customer/customer-contact";
import { DynamicForm } from "commons/ultilities/dynamic-form/components/dynamic-form";
import { useForm } from "commons/ultilities/dynamic-form/hooks/use-form";
import { observer } from "mobx-react-lite";
import { useStores } from "mobx-stores/_root-store";
import { useCallback, useEffect } from "react";
import { DialogForm } from "share-components/templates/form/dialog-form";
import { contactFormSchema } from "./schema";

export const EditContact = observer(() => {
  const {
    customerManagement: {
      contactManagement: { openEdit, setProp, selectdContact },
      getCustomerDetail,
      customerDetail,
    },
    catalogueStore: {
      getDepartmentTypes,
      departmentTypes,
      cataloguesToOptionItems,
    },
  } = useStores();
  const {
    form: { controls, isValid },
    getControl,
    submitHandler,
  } = useForm<UpdateContact>(contactFormSchema(), {
    departmentTypeId: selectdContact?.departmentTypeId || "",
    email: selectdContact?.email || "",
    fullName: selectdContact?.fullName || "",
    phoneNumber: selectdContact?.phoneNumber || "",
    customerId: customerDetail?.id || "",
  });

  useEffect(() => {
    getDepartmentTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (departmentTypes) {
      const options = cataloguesToOptionItems(departmentTypes);
      const control = getControl("departmentTypeId");
      control.setProp("optionItems", options);
    }
  }, [cataloguesToOptionItems, departmentTypes, getControl]);

  const saveHandler = useCallback(
    async (data: UpdateContact) => {
      try {
        if (!selectdContact?.id) {
          return;
        }
        await customerContactBusiness.update(selectdContact?.id, data);
        if (customerDetail?.id) {
          await getCustomerDetail(customerDetail?.id);
        }

        setProp("openEdit", false);
      } catch (ex) {
        console.error(ex);
      }
    },
    [customerDetail?.id, getCustomerDetail, selectdContact?.id, setProp]
  );
  return (
    <DialogForm
      open={openEdit}
      onClose={() => setProp("openEdit", false)}
      onCancelBtnClicked={() => setProp("openEdit", false)}
      onSaveBtnClick={async () => await submitHandler(saveHandler)}
      saveBtnProps={{
        disabled: !isValid,
      }}
    >
      <DialogTitle>Sửa liên hệ</DialogTitle>
      <DialogContent>
        <Box sx={{ marginTop: "10px" }}>
          <DynamicForm controls={controls}></DynamicForm>
        </Box>
      </DialogContent>
    </DialogForm>
  );
});
